export default "__VITE_ASSET__CMAhBJ4D__"